module.exports = __webpack_public_path__ + "img/artstation-icon.33805e35.png";